import "./media.css";
import { CgFacebook } from "react-icons/cg";
import { AiOutlineTwitter, AiOutlineInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
const Media = () => {
  return (
    <div className="m">
      <ul className="l">
        <li className="facebook">
          <a
            href="https://www.facebook.com/rental.yason"
            target="_blank"
            rel="noreferrer"
          >
            <CgFacebook
              style={{
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          </a>
        </li>
        <li className="instagram">
          <a
            href="https://www.instagram.com/yasonlovictoria"
            target="_blank"
            rel="noreferrer"
          >
            <AiOutlineInstagram
              style={{
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          </a>
        </li>
        <li className="twitter">
          <a
            href="https://mobile.twitter.com/lo_yason"
            target="_blank"
            rel="noreferrer"
          >
            <AiOutlineTwitter
              style={{
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          </a>
        </li>
        <li className="linkedin">
          <a
            href="https://www.linkedin.com/in/peter-yasir-773282228/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BgtjToExbR9eM2nuVwMHtZg%3D%3D"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn
              style={{
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Media;
